import { CirclePause } from 'lucide-react';
import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';

export const BannerBox = styled.div.attrs({
  className:
    'sticky top-14 z-40 mt-2 flex w-full items-center justify-between gap-2 bg-vantis-orange py-1.5 pr-2 pl-3 text-vantis-midnightblue',
})``;

export const BannerMessage = styled.div.attrs({
  className: 'flex min-w-0 items-center gap-1',
})``;

export const BannerIcon = styled(CirclePause).attrs({
  className: 'size-4 shrink-0',
  'aria-hidden': true,
})``;

export const BannerText = styled.p.attrs({
  className: `text-xs font-medium ${MASKED_TEXT_CLASS}`,
})``;
